/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-12-19 20:08:23
 * @LastEditors: hongye
 * @LastEditTime: 2025-06-03 20:46:06
 */
import request from '@/service/request'
enum Api {
  GET_PHONE = '/phoneManage/getPhone'
}

export default class getPhoneService {
  /**
   * 获取明文手机号
   * @param data
   * @returns
   */
  static getPhone(data: any): Promise<any> {
    return request.post(Api.GET_PHONE, data)
  }
  /**
   * 获取加密手机号
   * @param data
   * @param data.key
   * @param data.code  code=001 查寄件手机号 002收件手机号 003 下单人手机号
   **/
  static getPhoneV2(data: any): Promise<any> {
    return request.post('/sensitive/decrypt', data)
  }
}
